import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BackupTableIcon(props: IconProps) {
    return <Icon {...props} iconKey={"backup_table"}/>
}
